import React, { useState } from 'react'
import { Row, Col } from "antd";
import teamPic1 from "@/assets/img/home-page/coreTeam/1.png";
import teamPic2 from "@/assets/img/home-page/coreTeam/2.png";
import teamPic3 from "@/assets/img/home-page/coreTeam/3.png";
import teamPic4 from "@/assets/img/home-page/coreTeam/4.png";
import teamPic5 from "@/assets/img/home-page/coreTeam/5.png";
import teamPic6 from "@/assets/img/home-page/coreTeam/6.png";
import teamPic7 from "@/assets/img/home-page/coreTeam/7.png";
import teamPic10 from "@/assets/img/home-page/coreTeam/10.png";
import teamPic13 from "@/assets/img/home-page/coreTeam/13.png";
import teamPic14 from "@/assets/img/home-page/coreTeam/14.jpg";
import "./index.less";
import { useTranslation } from 'react-i18next';
const CoreTeam = ({ isMobile, pageStyle = {} }) => {
	const { t, i18n } = useTranslation();
	const teamArr = [
		{ title: 'Justin J.', subtitle: '创始人兼CEO', imgSrc: teamPic1, info: '' },
		{ title: 'Nicole J.', subtitle: '运营总监兼COO', imgSrc: teamPic10, info: '' },
		{ title: 'Dwight S.', subtitle: '高级后端工程师', imgSrc: teamPic13, info: '' },
		{ title: 'Jina X.', subtitle: '技术副总裁', imgSrc: teamPic4, info: '' },
		{ title: 'Lance L.', subtitle: '高级后端工程师', imgSrc: teamPic3, info: '' },
		{ title: 'Eric L.', subtitle: '高级前端工程师', imgSrc: teamPic5, info: '' },
		{ title: 'Kathy G.', subtitle: 'UI设计总监', imgSrc: teamPic6, info: '' },
		{ title: 'Alex L.', subtitle: '高级后端工程师', imgSrc: teamPic7, info: '' },
		{ title: 'Karen Z.', subtitle: 'UI设计师', imgSrc: teamPic2, info: '' },
		{ title: 'Adam S.', subtitle: '高级前端工程师', imgSrc: teamPic14, info: '' },
	]

	const renderPerson = () => (
		<div className="core-team-content">
			<div className="team-list">
				{
					teamArr.map((item, index) => (
						<div
							className="team-li"
							key={`${index}`}
						>
							<img alt="" src={item.imgSrc} className="team-li-pic" />
							{
								isMobile() ? (
									<div className="intro-box-mobile">
										<div className="intro-title">{item.title}</div>
										—
										{/* <div className="intro-subtitle intro-title">{item.subtitle}</div> */}
									</div>
								) : (
									<div className="intro-box">
										<div className="intro-title">{item.title}</div>
										{/* <div className="intro-subtitle intro-title">{item.subtitle}</div> */}
										{/* <div className="intro-info">{item.info}</div> */}
									</div>
								)
							}
						</div>
					))
				}
			</div>
		</div>
	)
  return (
    <div className="core-team" style={pageStyle}>
			<Row>
				<Col xs={3} sm={3}></Col>
				<Col xs={isMobile() ? 18 : 10} sm={18}>
					<div className="core-team-title" style={{ marginBottom: isMobile() ? 50 : 80 }}>
						<div className="team-title1">OUR GROUP</div>
						<div className="team-title2">Core Members</div>
						<div className="team-introduction">
						We are a mix tech team of highly skilled and incredibly dedicated craftsmen that. We have an unparalleled depth of experience and specialization in the planning, design, and development of high-profile, effective. 
						</div>
					</div>
				</Col>
				<Col xs={3} sm={3}></Col>
			</Row>
			{
				isMobile() ? (
					<Row>
						<Col xs={3} sm={3}></Col>
						<Col xs={18} sm={18}>
							{renderPerson()}
						</Col>
						<Col xs={3} sm={3}></Col>
					</Row>
				) : renderPerson()
			}
			{/* <div className="core-team-content">
				<div className="team-list">
					{
						teamArr.map((item, index) => (
							<div
								className="team-li"
								key={`${index}`}
							>
								<img alt="" src={item.imgSrc} className="team-li-pic" />
								<div className="intro-box">
									<div className="intro-title">{item.title}</div>
									<div className="intro-subtitle intro-title">{item.subtitle}</div>
									<div className="intro-info">{item.info}</div>
								</div>
							</div>
						))
					}
				</div>
			</div> */}
		</div>
  )
}

export default CoreTeam;
